import makeStyles from "@material-ui/core/styles/makeStyles";

import ErrorMessage from "common/components/fallbacks/error-message.component";
import loginStyles from "features/login-screen/login.styles";

const useStyles = makeStyles(loginStyles);

function LoginFallback() {
  const classes = useStyles();

  return (
    <div className={classes.fallBack}>
      <ErrorMessage />
    </div>
  );
}

export default LoginFallback;
